pieChart = (id, title, data, units, legend) ->
  units = "times" if units is undefined
  legend = false if legend is undefined
  chart = new Highcharts.Chart(
    chart:
      renderTo: id
      height: 250
      spacingBottom: 5
      spacingTop: 5
      spacingLeft: 5
      spacingRight: 5
    credits:
      enabled: false
    title:
      y: 5
      text: title
      floating: true
      style:
        color: "#333333"
        fontSize: "12px"
    legend:
      layout: "vertical"
      align: "right"
    tooltip:
      enabled: false
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      formatter: ->
        "<b>" + @point.name + "</b>: " + @y + " " + units + " (" + Highcharts.numberFormat(@percentage, 1) + "%)"
    plotOptions:
      pie:
        size: '47%'
        dataLabels:
          enabled: true
          color: '#333333'
          connectorColor: '#666666'
          distance: 20
          useHTML: true
          softConnector: false
          x: 0
          y: -9
          format: '<div class="label-percentage">{point.percentage:.2f}%<div><div class="label-name">{point.name}</div>'
        allowPointSelect: true
        showInLegend: legend
        cursor: "pointer"
        startAngle: 45
    series: [
      type: "pie"
      name: title
      data: data
    ]
  )

sparklineGraph = (id, title, data, start_date, mode, y_axis_text, plot_band_date) ->
  y_axis_text = null if y_axis_text is 'undefined'
  plot_band_date = null if plot_band_date is 'undefined'

  chart = new Highcharts.Chart(
    chart:
      renderTo: id
      defaultSeriesType: "line"
      height: 140
    credits:
      enabled: false
    title:
      text: null
    subtitle:
      text: null
    tooltip:
      formatter: ->
        dateText = (
          switch mode
            when 'day' then Highcharts.dateFormat("%a, %e %b", @x)
            when 'week' then Highcharts.dateFormat("%a, %e %b", Math.max(@x, start_date)) + ' - ' + Highcharts.dateFormat("%a, %e %b", @x + 6 * 24 * 3600 * 1000)
            when 'month' then Highcharts.dateFormat("%a, %e %b", Math.max(@x, start_date)) + ' - ' + Highcharts.dateFormat("%a, %e %b", moment(@x).endOf('month').utc())
          )
        dateText + "<br/>" + @series.name + ": <b>" + @y + "</b>"
    xAxis:
      type: 'datetime'
      dateTimeLabelFormats:
        day:   '%b %e'
        week:  '%b %e'
      title:
        text: null
      labels:
        enabled: true
        style:
          color: '#7d7d7d'
          fontWeight: 'normal'
          fontFamily: 'HelveticaNeueW01-45Ligh'
      lineWidth: 1
      tickLength: 5
      minPadding: 0.05
      plotBands:
        color: '#fff6f6'
        from: 0
        to: plot_band_date
        label:
          text: ('Estimated Data' if plot_band_date)
          style:
            fontSize: '9px'
            color: '#ff6666'
          align: 'right'
          x: -10
    yAxis:
      title:
        text: y_axis_text
        margin: 20
        style:
          color: '#7d7d7d'
          fontWeight: 'normal'
          fontFamily: 'HelveticaNeueW01-45Ligh'
          fontSize: '10px'
      labels:
        style:
          color: '#7d7d7d'
          fontWeight: 'normal'
          fontFamily: 'HelveticaNeueW01-45Ligh'
      gridLineWidth: 1
      gridLineColor: '#eee'
      lineWidth: 1
      tickLength: 5
      min: 0
    plotOptions:
      line:
        lineWidth: 1
        shadow: false
        marker:
          enabled: false
        states:
          hover:
            linewidth: 1
    series: [
      name: title
      data: data
    ]
    legend:
      enabled: false

    colors: ["#0077cc"]
  )

lineGraph = (id, title, multi_data, start_date, mode, y_axis_text) ->
  y_axis_text = null if y_axis_text is 'undefined'

  chart = new Highcharts.Chart(
    chart:
      renderTo: id
      defaultSeriesType: "line"
      height: 250
      zoomType: 'x'
      spacingRight: 20
    credits:
      enabled: false
    title:
      text: null
    subtitle:
      text: null
    tooltip:
      formatter: ->
        dateText = (
          switch mode
            when 'day' then Highcharts.dateFormat("%a, %e %b", @x)
            when 'week' then Highcharts.dateFormat("%a, %e %b", Math.max(@x, start_date)) + ' - ' + Highcharts.dateFormat("%a, %e %b", @x + 6 * 24 * 3600 * 1000)
            when 'month' then Highcharts.dateFormat("%a, %e %b", Math.max(@x, start_date)) + ' - ' + Highcharts.dateFormat("%a, %e %b", moment(@x).endOf('month').utc())
          )
        dateText + "<br/>" + @series.name + ": <b>" + @y + "</b>"
    legend:
      borderWidth: 0
    xAxis:
      type: 'datetime'
      dateTimeLabelFormats:
        day:   '%b %e'
        week:  '%b %e'
      title:
        text: null
      labels:
        enabled: true
        style:
          color: '#7d7d7d'
          fontWeight: 'normal'
          fontFamily: 'HelveticaNeueW01-45Ligh'
      gridLineWidth: 0
      lineWidth: 1
      tickLength: 5
      minPadding: 0.05
      showLastLabel: true
      maxZoom: 14 * 24 * 3600000 # fourteen days
    yAxis:
      title:
        text: y_axis_text
        margin: 20
        style:
          color: '#7d7d7d'
          fontWeight: 'normal'
          fontFamily: 'HelveticaNeueW01-45Ligh'
          fontSize: '10px'
      labels:
        style:
          color: '#7d7d7d'
          fontWeight: 'normal'
          fontFamily: 'HelveticaNeueW01-45Ligh'
      gridLineWidth: 1
      gridLineColor: '#eee'
      lineWidth: 1
      tickLength: 5
      min: 0
      minTickInterval: 1
    plotOptions:
      line:
        lineWidth: 1
        shadow: false
        marker:
          enabled: false
        states:
          hover:
            linewidth: 1
    series: multi_data
  )

@loadCharts = ->
  $('.sparkline-chart').each ->
    chart = $(@)

    $.ajax
      url: chart.data('chart-url')
      type: "GET"
      async: true
      dataType: "json"
      success: (data) ->
        sparklineGraph chart.attr('id'),
                       chart.data('title'),
                       data.data,
                       chart.data('start-date'),
                       chart.data('mode'),
                       chart.data('y-axis-text'),
                       chart.data('estimated-data-date')
        total = addCommas(data.total)
        if chart.data('link') != ''
          total_html = '<a href="'+chart.data('link')+'">'+total+'</a>'
        else
          total_html = total

        if chart.data('filter') is undefined
          filter = ''
        else
          filter = chart.data('filter')

        $('#total_'+chart.data('chart-type')+'_'+filter).html(total_html)

        return

  $('.line-chart').each ->
    chart = $(@)
    lineGraph @.id,
              chart.data('title'),
              chart.data('chart'),
              chart.data('start-date'),
              chart.data('mode'),
              chart.data('y-axis-text')

  $('.pie-chart').each ->
    chart = $(@)
    pieChart @.id,
             chart.data('title'),
             chart.data('chart') #,
             # chart.data('start-date')

global.loadCharts = @loadCharts
